import { render, staticRenderFns } from "./FootList.vue?vue&type=template&id=4b4420dc&scoped=true"
import script from "./FootList.vue?vue&type=script&lang=js"
export * from "./FootList.vue?vue&type=script&lang=js"
import style0 from "./FootList.vue?vue&type=style&index=0&id=4b4420dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4420dc",
  null
  
)

export default component.exports